import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Chip from 'components/common/chip';
import connect from 'components/lib/connect';
import WrappedItemsContainer from 'components/common/containers/wrapped_items_container';

export function SelectedUsers({ onDeleteItem, selectedItems }) {
  if (!selectedItems.length) {
    return null;
  }

  return (
    <WrappedItemsContainer inset="none">
      {selectedItems.map(item => (
        <Chip
          data-aid={`selectedUser-${item.id}`}
          key={item.id}
          label={item.label}
          onDelete={onDeleteItem.bind(null, item.id)}
        />
      ))}
    </WrappedItemsContainer>
  );
}

const SelectedUsersContainer = connect(mapStateToProps)(SelectedUsers);

SelectedUsersContainer.propTypes = {
  onDeleteItem: PropTypes.func,
  userIds: PropTypes.arrayOf(PropTypes.string),
};

function mapStateToProps({ getProvider }, { userIds }) {
  const agentProvider = getProvider('agents');
  const currentAgent = getProvider('currentAgent').get();

  let selectedItems = !agentProvider.isLoading()
    ? _.sortBy(
        userIds
          .map(id => agentProvider.find(id))
          .map(agent => {
            const you = agent.id === _.get(currentAgent, 'id') ? ' (You)' : '';
            return {
              id: agent.id,
              label: `${agent.name || agent.email}${you}`,
            };
          }),
        option => option.label.toLowerCase()
      )
    : [];

  return {
    selectedItems,
  };
}
export default SelectedUsersContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/team_editor/selected_users.jsx